import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    ReferenceField,
    DateField,
    BooleanField,
} from 'react-admin';
import RecurrenceField from '../schedules/RecurrenceField';
import JobTitle from './JobTitle';

const JobShow = props => (
    <Show title={<JobTitle />} {...props}>
        <SimpleShowLayout>
        <TextField source="id" />
            <ReferenceField label="Resource" source="schedule_id" reference="schedules">
                <ReferenceField label="Resource" source="resource_id" reference="resources">
                    <TextField source="name" />
                </ReferenceField>
            </ReferenceField>
            <ReferenceField label="Target" source="schedule_id" reference="schedules">
                <ReferenceField label="Target" source="target_id" reference="targets">
                    <TextField source="name" />
                </ReferenceField>
            </ReferenceField>
            <ReferenceField label="Schedule" source="schedule_id" reference="schedules">
                <RecurrenceField source="rrule" />
            </ReferenceField>
            <DateField source="start_time" showTime />
            <DateField source="end_time" showTime label="Max execution time" />
            <BooleanField source="is_running" />
            <BooleanField source="is_finished" />
            <TextField source="error" emptyText="-" />
            <DateField source="started_time" showTime emptyText="-" />
            <DateField source="finished_time" showTime emptyText="-" />
            <DateField source="queue_time" showTime emptyText="-" />

        </SimpleShowLayout>
    </Show>
);

export default JobShow;